import React from 'react'
import StepOnePersonalForm from '../components/step-one-form.component'
import StepTwoComplementaryForm from '../components/step-two-form.component'
import StepFourPasswordForm from '../components/step-four-form.component'
import StepFiveTermsAndConditionsForm from '../components/step-five-form.component'
import StepSixMuvicardForm from '../components/step-six-form.component'
import { AxiosService } from './../../../../../services/axios.service'
import BillingAddressStep from '../components/billing-address-step.component'

const baseUrl = 'cliente/'

export const UpdateClientService = {
	getSections: function () {
		const { complementary, personal, termsAndConditions, muvicard } = this
		const { clientId } = this.props

		let itensArray = [
			{
				title: 'Dados Pessoais',
				content: (
					<StepOnePersonalForm
						initialValues={personal}
						ref={'stepOne'}
						onSubmit={this.handleSubmitStepOne}
					/>
				),
			},
			{
				title: 'Dados complementares',
				content: (
					<StepTwoComplementaryForm
						initialValues={complementary}
						ref={'stepTwo'}
						onSubmit={this.handleSubmitStepTwo}
					/>
				),
			},
			{
				title: 'Endereço de cobrança',
				content: (
					<BillingAddressStep
						ref={'billingAddress'}
						onAdvance={this.goToNextStep}
						onBack={this.goToBackStep}
						onSubmit={this.handleSubmitBillindAddressStep}
						clientId={clientId}
						{...this.props}
					/>
				),
			},
			{
				title: 'Senha',
				content: (
					<StepFourPasswordForm
						ref={'stepFour'}
						onSubmit={this.handleSubmitStepFour}
					/>
				),
			},
			{
				title: 'Termos e condições de uso',
				content: (
					<StepFiveTermsAndConditionsForm
						initialValues={termsAndConditions}
						ref={'stepFive'}
						onSubmit={this.handleSubmitStepFive}
						{...this.props}
					/>
				),
			},
		]

		var muvicardContainer = muvicard.hasValidMuvicard && {
			title: 'Muvicard',
			content: (
				<StepSixMuvicardForm initialValues={muvicard} {...this.props} />
			),
		}
		if (muvicardContainer) itensArray.push(muvicardContainer)

		return itensArray
	},
	post: (data) =>
		AxiosService.post(baseUrl + 'atualizar-dados', data).then(
			({ data }) => data
		),
	get: () => AxiosService.get(baseUrl + 'dados').then(({ data }) => data.data),
	updateOneClickBuy: () =>
		AxiosService.post(baseUrl + 'desativar-muvicard-one-click').then(
			({ data }) => data
		),
}
